import { render, staticRenderFns } from "./CiSum.vue?vue&type=template&id=60b21658&scoped=true&"
import script from "./CiSum.vue?vue&type=script&lang=js&"
export * from "./CiSum.vue?vue&type=script&lang=js&"
import style0 from "./CiSum.vue?vue&type=style&index=0&id=60b21658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b21658",
  null
  
)

component.options.__file = "CiSum.vue"
export default component.exports